module.exports = __webpack_public_path__ + "img/default-nav-subnav-ford.4c83f616.png";